import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { ArrowLeft } from 'lucide-react';

export default function NotFoundPage() {
  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center gap-6 py-24 px-6" data-testid="not-found-page">
      <Helmet>
        <title>404 — Страница не найдена | Ali India Tours</title>
        <meta name="robots" content="noindex, nofollow" />
        <meta name="prerender-status-code" content="404" />
        <meta http-equiv="Status" content="404 Not Found" />
        <meta property="og:title" content="404 — Страница не найдена" />
        <meta name="description" content="Запрошенная страница не существует. Вернитесь на главную и выберите тур." />
      </Helmet>
      <p className="overline text-saffron">Ошибка 404</p>
      <h1 className="font-serif-display text-5xl md:text-7xl text-center">Страница не найдена</h1>
      <p className="text-foreground/70 text-center max-w-lg">
        Запрошенная страница не существует или была удалена. Вернитесь на главную и выберите один из наших туров.
      </p>
      <Link
        to="/"
        className="inline-flex items-center gap-2 border border-foreground/20 hover:border-saffron px-6 py-3 uppercase tracking-widest2 text-xs font-bold transition-colors"
        data-testid="not-found-home-link"
      >
        <ArrowLeft size={14} /> На главную
      </Link>
    </div>
  );
}
